<template>
  <div>
    <!-- Header Row -->
    <div class="row mb-2 pe-4">
      <div class="col-lg-8 col-md-7 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">SALES CHANNEL</h3>
        </div>
      </div>
      <div class="col-lg-4 col-md-5 col-12 d-flex justify-content-md-end justify-content-start ps-3 ps-md-0 mt-2 mt-md-0">
        <material-button
          @click="createBranch()"
          :disabled="disableBtnSubmit"
          class="mx-2 btn-background btn-sm"
        >
          ADD SALE CHANNEL
        </material-button>
      </div>
    </div>

    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="notifications">
            <material-alert
              v-if="error"
              color="danger"
              icon="ni ni-like-2 ni-lg"
              dismissible
            >
              {{ error }}
            </material-alert>
          </div>

          <div class="col-lg-12 col-md-12 col-12 mx-auto" v-if="isLoadData">
            <!-- Search & Download Row -->
            <div class="row my-3 d-flex align-items-center">
              <div class="col-lg-6 col-md-6 col-12 mb-2 mb-md-0">
                <input
                  class="nosubmit w-100"
                  type="search"
                  id="keyword_search"
                  v-model="searchKeyword"
                  extraClass
                  name="keyword_search"
                  placeholder="Search by name, address"
                  @input="onChangesearchKeyword"
                />
              </div>
              <div class="col-lg-6 col-md-6 col-12 d-flex justify-content-md-end justify-content-start">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle btn-sm"
                    type="button"
                    id="dropdownMenuButton1"
                    style="margin-top: 0px;"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                  >
                    {{ $t('download') }}
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <li>
                      <a class="dropdown-item" @click="exportFile('csv')" href="#">Export CSV</a>
                    </li>
                    <li>
                      <a class="dropdown-item" @click="exportFile('xlsx')" href="#">Export Excel</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Table (Desktop) / Card list (Mobile) -->
            <div class="row mt-4">
              <div class="col-12">
                <div class="card-custom">

                  <!-- Desktop Table: hidden on mobile -->
                  <div class="table-responsive p-0 custom-table d-none d-md-block">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-center font-weight-bolder">ID</th>
                          <th class="text-center font-weight-bolder">
                            {{ $t('Physical_Branch_Name') }}
                          </th>
                          <th class="text-center font-weight-bolder">
                            {{ $t('Sale_Channel_Name') }}
                          </th>
                          <th class="text-center font-weight-bolder">Menuset</th>
                          <th class="text-center font-weight-bolder">{{ $t('status') }}</th>
                          <th class="text-center font-weight-bolder">{{ $t('action') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(value, key) in branches" :key="key">
                          <td class="text-center text-xss w-5">
                            {{ value.id_text }}
                          </td>
                          <td class="text-center text-xss w-25">
                            {{ value.physical_branch?.name }}
                          </td>
                          <td class="text-center text-xss w-25">
                            {{ value.branch_name }}
                          </td>
                          <td class="text-center text-xss">
                            {{ menusetNames(value) }}
                          </td>
                          <td class="align-middle text-center w-10">
                            <span
                              class="badge badge-sm"
                              v-bind:class="
                                value.status == 1
                                  ? 'bg-gradient-success'
                                  : 'bg-danger'
                              "
                            >
                              {{ value.status == 1 ? "Active" : "Deactive" }}
                            </span>
                          </td>
                          <td class="w-10 align-middle text-center text-sm w-15">
                            <a
                              class="btn btn-link text-dark px-3 mb-0"
                              href="javascript:;"
                              @click="editBranch(value.id)"
                            >
                              <i class="fas fa-pencil-alt text-dark me-2" aria-hidden="true"></i>Edit
                            </a>
                            <a
                              class="btn btn-link text-dark px-3 mb-0"
                              data-bs-toggle="modal"
                              data-bs-target="#modalConfirm"
                              href="javascript:;"
                              @click="confirmDuplicate(value.id)"
                            >
                              <i class="far fa-copy text-dark me-2" aria-hidden="true"></i>Duplicate
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Mobile Card List: hidden on desktop -->
                  <div class="d-block d-md-none pt-2 pb-3">
                    <div
                      v-for="(value, key) in branches"
                      :key="'card-' + key"
                      class="mobile-card mb-3 p-3"
                    >
                      <div class="d-flex justify-content-between align-items-start mb-2">
                        <span class="text-xss text-muted fw-bold">{{ value.id_text }}</span>
                        <span
                          class="badge badge-sm"
                          v-bind:class="
                            value.status == 1
                              ? 'bg-gradient-success'
                              : 'bg-danger'
                          "
                        >
                          {{ value.status == 1 ? "Active" : "Deactive" }}
                        </span>
                      </div>

                      <div class="mb-1">
                        <span class="mobile-label">{{ $t('Physical_Branch_Name') }}:</span>
                        <span class="text-xss ms-1">{{ value.physical_branch?.name }}</span>
                      </div>
                      <div class="mb-1">
                        <span class="mobile-label">{{ $t('Sale_Channel_Name') }}:</span>
                        <span class="text-xss ms-1">{{ value.branch_name }}</span>
                      </div>
                      <div class="mb-2">
                        <span class="mobile-label">Menuset:</span>
                        <span class="text-xss ms-1">{{ menusetNames(value) }}</span>
                      </div>

                      <div class="d-flex gap-2 justify-content-end mt-2">
                        <a
                          class="btn btn-link text-dark px-0 mb-0 me-3"
                          href="javascript:;"
                          @click="editBranch(value.id)"
                        >
                          <i class="fas fa-pencil-alt text-dark me-1" aria-hidden="true"></i>Edit
                        </a>
                        <a
                          class="btn btn-link text-dark px-0 mb-0 me-3"
                          data-bs-toggle="modal"
                          data-bs-target="#modalConfirm"
                          href="javascript:;"
                          @click="confirmDuplicate(value.id)"
                        >
                          <i class="far fa-copy text-dark me-1" aria-hidden="true"></i>Duplicate
                        </a>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="pagination.last_page > 1"
                    class="pagination-mobile-wrapper"
                  >
                    <pagination
                      :pagination="pagination"
                      :current_page="pagination.current_page"
                      :last_page="pagination.last_page"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalConfirm
        :message="confirmMessage"
        :process-yes="processYes"
      />
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>

    <form :action="`${actionDownload}/merchant/download-branches`" method="POST">
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCodeExport" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="search_keyword" :value="searchKeyword" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Pagination from "@/components/Pagination.vue";
import "bootstrap/js/dist/modal";
import MaterialButton from "@/components/MaterialButton.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import SettingStoreService from "../../../services/settingStore.service";
import TokenService from "../../../services/token.service";
import ModalConfirm from "@/components/ModalConfirm.vue";
import $ from "jquery";
export default {
  name: "find-branch",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    ModalConfirm,
    Pagination,
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      branches: [],
      searchKeyword: "",
      searchTimerId: null,
      pagination: {},
      page: 1,
      branchId: null,
      isLoadData: false,
      merchantCode: "",
      action_export: 'csv',
      actionDownload: process.env.VUE_APP_BASE_URL,
      token: TokenService.getLocalAccessToken(),
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCodeExport: localStorage.getItem("MERCHANT_CODE", ""),
    };
  },
  computed: {
    confirmMessage() {
      return "Duplicate this sale channel with all its settings? The copy is created deactivated.";
    },
  },
  created() {
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.getList(this.page);
  },
  mounted() {
    const code = localStorage.getItem("MERCHANT_CODE", "");
    this.merchantCode = code ? `/${code}` : "";
  },
  methods: {
    // Channels not re-saved since multi-menuset support have no menusets rows,
    // so fall back to the single menuset they were created with.
    menusetNames(branch) {
      if (branch?.menusets?.length) {
        return branch.menusets.map((menuset) => menuset.name).join(', ');
      }
      return branch?.menuset?.name ?? '';
    },
    exportFile(type = 'csv') {
      this.action_export = type;
      setTimeout(() => {
        $('#downloadForm').click();
      }, 150);
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    gotoOperationHours() {
      this.$router.push('/branch/operation-hours');
    },

    onChangesearchKeyword(event) {
      this.searchKeyword = event.target.value;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.getList(this.page);
      }, 1000);
    },

    getList(page) {
      this.isLoadData = false;
      this.branches = [];
      this.showLoader();
      var dataForm = {
        search_keyword: this.searchKeyword,
        page: page,
      };
      SettingStoreService.getDataBranches(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.branches = response.data.data.items;
            this.pagination = response.data.data;
            this.page = this.pagination.current_page;
            this.$router.push({
              query: Object.assign({}, this.$route.query, { page: this.page }),
            });
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    createBranch() {
      this.$router.push("/branch");
    },

    editBranch(id) {
      this.$router.push("/branch/" + id + "?page=" + this.page);
    },

    processYes() {
      this.duplicateBranch();
    },

    confirmDuplicate(branchId) {
      this.branchId = branchId;
      $(".btn-confirm-modal").click();
    },

    // M1019: the copy opens straight away, so the merchant can rename it and switch it on there.
    duplicateBranch() {
      $(".btn-close-modal").click();
      this.showLoader();
      SettingStoreService.duplicateBranch(this.branchId).then(
        (response) => {
          this.hideLoader();
          if (response.data.result.isSuccess) {
            this.editBranch(response.data.data.id);
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>

<style scoped>
.text-title {
  color: #133067 !important;
  font-weight: 600 !important;
  font-size: 20px !important;
  font-family: "Roboto Slab", sans-serif !important;
}

.text-label {
  color: #5b848d !important;
  font-weight: 500 !important;
  font-size: 17px !important;
  font-family: "Roboto Slab", sans-serif !important;
}

.checkbox-auto-save label {
  padding-top: 11px !important;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #ffbe30;
  outline: none;
  border: none;
  border-bottom: 1px solid #ffbe30;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.custom-title {
  word-break: break-all;
  max-width: 200px;
  white-space: normal;
}

/* Mobile card styles */
.mobile-card {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.mobile-label {
  font-weight: bold;
  color: #000;
}

/* Ensure dropdown button aligns well on mobile */
@media (max-width: 767px) {
  .dropdown .btn {
    margin-top: 4px !important;
  }

  .pagination_block {
    padding: 0 !important;
  }
}
</style>